module.exports = __webpack_public_path__ + "img/logo.49d6f8d.png";